// removed by extract-text-webpack-plugin
module.exports = {"switch":"rO2Lo4cY8fq5vv-NGLjeH","slider":"_2q6yHhsGKDbcKVFhfhXeej"};


//////////////////
// WEBPACK FOOTER
// ./src/component/Forms/ToogleSwitch/style.css
// module id = 1403
// module chunks = 0